<template>
  <div>
    <v-main class="bg">
      <poker-table :name="displayID" @chat-message="sendChat"></poker-table>
    </v-main>

  </div>
</template>

<script>
import PokerTable from "./PokerTable";
export default {
  name: "PokerTablePage",
  components: {PokerTable},

  data() {
    return {
      displayID: "",
    }
  },

  created() {
    this.displayID = this.$route.query.accountName;
    this.$store.commit("setActiveChatAccount", this.displayID);

    // ! update title
    document.title = `Watching Table - ${this.displayID}`;
  },

  methods: {
    sendChat(data) {
      let acc = data.acc;
      let text = data.text;
      this.$socket.emit("send_chat", {'displayID': acc.name, 'text': text});
    }
  }
}
</script>

<style scoped>
  .bg {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #1E1E1E;

    width: 100vw;
    height: 100vh;
  }

  .loading {
    position: absolute;

    background-color: rgba(0, 0, 0, 0.6);

    top: 0;
    bottom: 0;
    right: 0;
    left: 0;

    width: 100%;
    height: 100%;

    z-index: 10;

    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
